import Vue from 'vue'
import { UTILS, UA, COOKIE } from '../utils'
import { API } from '../api'
import { CONFIG } from '../config'
import App from '../../App.vue'
import store from '../store'
import router from '../router'

export default {

    checkPlatForm() {

        var curUrl = window.location.href;
        console.log('login.checkPlatForm-----', curUrl)

        // 五行穿衣页面过来的手动设置一下platform值为55
        if(curUrl.indexOf('wx.yxdxt.com/dress') != -1) {
            CONFIG.platform_params.platform = 55;
            // this.checkLogin();
            // return;
        }

        // 五行穿衣平台用token登录
        if(CONFIG.platform == 'wxcy' && curUrl.indexOf('dress.yxdxt.com') != -1) {
            this.checkWxcyPlatForm();
            return;
        }

        // 开发环境或者预发布
        if(process.env.NODE_ENV == 'test' || process.env.NODE_ENV == 'pre-release') {
            this.checkTestPlatForm();
            return;
        }
        // 微信或者pc微信
        if(UA.isWeChat() || UA.isPcWeChat()) {
            // 微信平台:QQ的链接跳转到微信平台；
            if(curUrl.indexOf('qq') != -1) {
                var path = UTILS.getQueryString('path'),
                    wechatUrl = UTILS.getWechatUrlByCurrentPath(path);
                window.location.href = wechatUrl;
            } else if (curUrl.indexOf('b.yxdxt') != -1) {
                window.location.href = CONFIG.wechat_url;
                // console.log('wechat-------', CONFIG.wechat_url)
            } else {
                this.checkLogin();
            }
        }else if(UA.isQQ()) {
            // QQ平台:微信的链接跳转到QQ平台；
            if(curUrl.indexOf('qq') == -1) {
                var qqUrl = UTILS.getQQUrlByCurrentPath(window.location.pathname);
                window.location.href = qqUrl;
            } else if (curUrl.indexOf('b.yxdxt') != -1) {
                window.location.href = CONFIG.qq_url;
                // console.log('qq-------', CONFIG.qq_url)
            }else {
                this.checkLogin();
            }
        }else {
            this.checkLogin();
        }
    },
    checkLogin() {
        var me = this, userInfo;
        // 超过30min后，删除数据，重新授权登录
        var oldTime = parseInt(parseInt(window.localStorage.getItem('H5_Fate_TimeStamp'))/1000/60);
        var newTime = parseInt((new Date()).getTime()/1000/60);
        var temp = newTime - oldTime;
        if(temp > 30) {
            window.localStorage.removeItem("H5_Fate_UserInfo");
        }
        userInfo = JSON.parse(window.localStorage.getItem("H5_Fate_UserInfo"));
        console.log('localStorage-----', temp, userInfo);

        var userToken = userInfo && userInfo.token ? userInfo.token : null;
        // 其他平台用sessionstorage缓存用户登录信息
        if (userToken && userToken != null && userToken != 'null') {
            API.checkLogin({
                'token': userToken
            }, function (data) {
                store.state.userData = userInfo ? userInfo : {};
                store.state.userData = Object.assign({
                    'token': userToken
                }, data);
                me.renderView();
            }, function (data) {
                console.error("checkLogin-----failed", data)
                me.loginFailed();
            })
        }else{ 
            me.thirdLogin();
        }
    },
    /**
     * 跳转到授权登录
     */
    thirdLogin(loginType, sucFunc) {
        var me = this;
        var code = UTILS.getQueryString("code");     // 注意：1个code请求登录thirdLogin的接口只能请求1次
        var type = CONFIG.platform == 'wechat' ? 3 : 6;  // 微信3，其他是6
            type = loginType ? loginType : type;
        var params = code ? {
            'code': code,
            'type': type
        } : null;
        if (params) {
            API.thirdLogin(params, function (data) {
                store.state.userData = data;
                window.localStorage.setItem("H5_Fate_TimeStamp", (new Date()).getTime());
                window.localStorage.setItem("H5_Fate_UserInfo", JSON.stringify(data));
                console.log('thirdLogin-----授权登录成功', data);
                if(sucFunc && typeof(sucFunc) == 'function') {
                    sucFunc();
                }
                me.renderView();
            }, function (data) {
                console.error("thirdLogin-----授权登录失败", data.status_code);
                if(data.status_code == 1004) {
                    window.alert('因为违反国家相关法律规定账号被封');
                }else if(data.status_code == 1010){
                    console.log('弹框提示授权');
                    me.renderView();
                    store.state.showAuthRemind = true;
                }else {
                    me.loginFailed();
                }
            });
        } else {
            me.loginFailed();
        }
    },
    /**
     * 第三方登录失败
     */
    loginFailed() {
        window.localStorage.removeItem("H5_Fate_UserInfo");
        window.localStorage.removeItem("H5_Fate_TimeStamp");
        if(CONFIG.platform == 'qq') {
            window.location.href = CONFIG.getQQAuthUrl();
        }else if(CONFIG.platform == 'wechat' || CONFIG.platform == 'wxcy') {
            window.location.href = CONFIG.getWechatAuthUrl();
        }
    },
    /**
     * 根据url上的token来登录
     * @param {} token 
     */
    checkToken(token) {
        console.log('checkToken', token)
        let me = this;
        API.checkLogin({
            'token': token
        }, function (data) {
            store.state.userData = data ? data : {};
            if(token) {
                store.state.userData = Object.assign({
                    'token': token
                }, data);
                window.localStorage.setItem("H5_Fate_TimeStamp", (new Date()).getTime());
                window.localStorage.setItem("H5_Fate_UserInfo", JSON.stringify(data));
            }
            me.renderView();
        }, function (data) {
            console.error("checkTokenLogin-----failed", data)
            me.thirdLogin();
        })
    },
    /**
     * 五行穿衣平台登录
     * @returns 
     */
    checkWxcyPlatForm() {
        var curUrl = window.location.href;
        var token = window.decodeURIComponent(UTILS.getQueryString("token")); 
        var platform = UTILS.getQueryString("platform");
        console.log('checkPlatForm-------', curUrl, UA.isWeChat(), UA.isQQ(), UA.isPC(), UA.isPcWeChat())
        console.log('checkPlatForm-------', platform);
        store.state.platform = platform ? parseInt(platform, 10) : 0;
        if(token != null && token != 'null') {
            this.checkToken(token);
            window.localStorage.setItem("H5_Fate_Token", token);
            window.localStorage.setItem("H5_Fate_PlatForm", platform);
            return;
        }
        // 检查缓存
        var lsToken = window.localStorage.getItem("H5_Fate_Token"),
            lsPlatForm = window.localStorage.getItem("H5_Fate_PlatForm");
            lsPlatForm = lsPlatForm ? parseInt(lsPlatForm, 10) : 0;
        console.log('checkPlatForm-------', lsToken, lsPlatForm);
        if(lsToken != null && lsToken != 'null' && lsPlatForm == 55) {
            store.state.platform = lsPlatForm;
            this.checkToken(lsToken);
        }
    },
    /**
     * 测试平台登录
     */
    checkTestPlatForm() {
        let lsUid = window.localStorage.getItem("H5_Fate_Test_Uid");
        store.state.userUid = (lsUid != null && lsUid != 'null') ? parseInt(lsUid, 10) : 0 ;
        var uid = UTILS.getQueryString("uid");
        store.state.userUid = uid != null ? parseInt(uid, 10) : store.state.userUid;
        console.error('checkTestPlatForm', store.state.userUid);
        if(store.state.userUid == 0) {
            this.checkLogin();
        }else {
            store.dispatch('user/getUserInfo', {
                id: store.state.userUid,
                cb: (data) => {
                    store.state.userData = Object.assign({}, data);
                    store.state.userData.isnewuser = 0;
                    store.state.userData.info = Object.assign({}, data);
                    console.log('getUserInfo-----', store.state.userData);
                    window.localStorage.setItem("H5_Fate_Test_Uid", store.state.userUid);
                    this.renderView();
                }
            });
        }
    },
    /**
     * 渲染页面
     */
    renderView() {

        // 初始化vue的app
        window.AppFate = new Vue({
            el: '#app',
            template: '<App/>',
            router,
            store,
            components: { App }
        });

        // 横竖屏检查及提示
        this.checkOrientation();
        window.addEventListener("onorientationchange" in window ? "orientationchange" : "resize", this.checkOrientation, false);
    },
    checkOrientation() {
        var hoverDiv = document.getElementById('orientOverLay');
        if (window.orientation == 90 || window.orientation == -90) {
            //横屏
            hoverDiv.style.display = 'block';
        } else {
            //竖屏
            hoverDiv.style.display = 'none';
        }
    }
}